module.exports = __webpack_public_path__ + "static/media/Hisense-how-does-it-work.8f7b7aed.jpg";